import { useTranslation } from 'react-i18next';
import { IcWarn } from './Icons';
import { bannerDetail, needsOwner } from './model';

/** "N screens need you" — shown above the toolbar when any screen has a fault, is offline, or has its app closed. */
export default function NeedsYouBanner({ screens, onOpen }) {
  const { t } = useTranslation();
  const need = (screens || []).filter((s) => needsOwner(s.state));
  if (!need.length) return null;
  return (
    <div className="pp-scr-banner" data-testid="needs-you-banner">
      <span className="pp-scr-bt"><IcWarn /><span><b>{t('sh.banner_title', { count: need.length })}</b><span className="pp-scr-bs">{bannerDetail(t, screens)}</span></span></span>
      <button type="button" className="pp-scr-btn danger" onClick={() => onOpen(need[0].id)}>{t('sh.open_screen', { name: need[0].name })}</button>
    </div>
  );
}
